import axios from 'axios';

// In production (mowapp.us), call the backend directly on port 3001.
// In dev, all /api requests go through the Vue CLI dev server proxy to the live backend.
const baseURL = window.location.hostname === 'mowapp.us'
  ? 'https://mowapp.us:3001/api'
  : '/api';

const api = axios.create({
  baseURL,
  withCredentials: true,
  headers: {
    'Content-Type': 'application/json',
  },
});

api.interceptors.response.use(
  (response) => response,
  (error) => {
    const status = error.response?.status;
    const code = error.response?.data?.code;

    if (status === 403 && code === 'PLAN_DOWNGRADED_TEAM_DISABLED') {
      window.location.href = '/#/login';
      return Promise.reject(error);
    }

    if (error.response && error.response.status === 401) {
      const currentPath = window.location.hash.replace('#', '') || window.location.pathname;
      if (currentPath !== '/login') {
        window.location.href = '/#/login';
      }
    }
    return Promise.reject(error);
  }
);

export default api;
